import React from 'react';
import { motion } from 'framer-motion';
export function PhilosophySection() {
  return <section className="py-12 md:py-16 px-4 relative" data-id="element-143">
      <div className="max-w-3xl mx-auto text-center" data-id="element-144">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-145">
          <p className="text-2xl md:text-4xl font-display font-bold leading-tight" data-id="element-146">
            La mayoría mira <span className="text-gray-500" data-id="element-147">emoción.</span>
            <br data-id="element-148" />
            Pocos ven <span className="text-brand-green" data-id="element-149">estructura.</span>
          </p>

          <div className="w-12 h-px bg-brand-border mx-auto my-8" data-id="element-150" />

          <p className="text-xl md:text-2xl text-gray-300 font-display font-medium" data-id="element-151">
            Nunca te faltó esfuerzo.
            <br data-id="element-152" />
            <span className="text-white" data-id="element-153">Te faltó contexto.</span>
          </p>

          <p className="text-base md:text-lg text-gray-400 leading-relaxed max-w-2xl mx-auto pt-4" data-id="element-154">
            Porque mientras otros reaccionan a los goles, el partido ya estaba
            siendo moldeado horas antes del inicio.
          </p>
        </motion.div>
      </div>
    </section>;
}